import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@shared/ui/alert-dialog";

interface ServiceOrderSuccessDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onGoToList: () => void;
  orderCount: number;
}

export const ServiceOrderSuccessDialog: React.FC<
  ServiceOrderSuccessDialogProps
> = ({ isOpen, onClose, onGoToList, orderCount }) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent className="max-w-sm">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-lg font-semibold">
            Service orders created
          </AlertDialogTitle>
          <AlertDialogDescription className="text-gray-600">
            Your {orderCount} service order{orderCount > 1 ? "s" : ""} were created successfully.{" "}
            Would you like to go back to the list view or stay here to create more?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            onClick={onClose}
            className="border-gray-300 bg-white text-gray-700 hover:bg-gray-100"
          >
            Stay here
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onGoToList}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2"
          >
            Go to list view
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
